import {
  anAutomation,
  anAutomationPage,
  mockAutomationQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const mockAutomation = {
  id: '1',
  name: 'Automation 1',
  description: 'Automation 1 description',
  cseResourceType: 'ENTITY',
  cseResourceSubTypes: ['_username'],
  enabled: true,
  executionTypes: ['ON_DEMAND'],
  playbookId: 'playbook-1',
};

export const handlers = [
  mockAutomationQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(50);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          automations: anAutomationPage({
            hasNextPage: false,
            total: 1,
            objects: [
              anAutomation({
                ...mockAutomation,
              }),
            ],
          }),
        },
      });
    }
  ),
];
